const PSEvents = require('PSEvents');
const PSState = require('PSState');
const PSUtils = require('PSUtils');
const PSPlatform = require('PSPlatform');

cc.Class({
    extends: cc.Component,

    properties: {
        targetNode: cc.Node,
        landscapeDesktopCoefficient: 1,
        landscapeMobileCoefficient: 1,
        portaitDesktopCoefficient: 0,
        portaitMobileCoefficient: 0,
    },

    ctor() {
        this.originScale = 1;
    },

    onLoad () {
        if (!this.targetNode) {
            this.targetNode = this.node;
        }
        if (PSPlatform.isMobile) {
            this.landscapeCoefficient = this.landscapeMobileCoefficient;
            this.portaitCoefficient = this.portaitMobileCoefficient;
        } else {
            this.landscapeCoefficient = this.landscapeDesktopCoefficient;
            this.portaitCoefficient = this.portaitDesktopCoefficient;
        }
        this.scale = 1;
        this.originScale = this.node.scale;
        this.coefficient = this.landscapeCoefficient;

        this.listener = (data) => this._updateTopMargin(data);
        this.resizeManager = cc.find('ResizeManager').getComponent('ResizeManager');
        this.resizeManager.appendNode(this);
    },

    start () {
        PSEvents.getLastAndSubscribe(PSEvents.GAME_INNTER_CANVAS_SIZE_CHANGED, this.listener);
    },

    onDestroy () {
        PSEvents.unsubscribe(PSEvents.GAME_INNTER_CANVAS_SIZE_CHANGED, this.listener);
        this.resizeManager.removeNode(this);
    },

    _updateTopMargin(data) {
        const canvasHeigh = cc.view.getVisibleSize().height;

        const h = PSUtils.convertToGameCanvasHeight(data.topValue);
        const innerScale = h / canvasHeigh * this.coefficient;
        this.scale = Math.max(0.01, (1 - innerScale));

        this.node.scale = this.scale * this.originScale;
    },

    onViewResize(_, aspectRatio) {
        this.coefficient = aspectRatio > 1 ? this.landscapeCoefficient : this.portaitCoefficient;
        this._updateTopMargin(PSState.gameInnerCanvasSize);
    },
});
